import React from 'react';
import { createContext, useState } from 'react';
import { getTwelveAMOfToday } from '../helpers/dates';
import { TransactionFilter } from 'src/common/types';

export type TransactionFilterContextType = {
  transactionFilter: TransactionFilter;
  setTransactionFilter: React.Dispatch<React.SetStateAction<TransactionFilter>>;
};

type TransactionFilterContextProps = {
  children: React.ReactNode;
};

export const TransactionFilterContext = createContext<TransactionFilterContextType | undefined>(
  undefined,
);

export function TransactionFilterProvider({ children }: TransactionFilterContextProps) {
  const today = getTwelveAMOfToday();
  const weekAgo = new Date(today);
  weekAgo.setDate(today.getDate() - 7);

  const [transactionFilter, setTransactionFilter] = useState<TransactionFilter>({
    selectedDates: [weekAgo, today],
    dropdownFilters: { transactionType: '', responseCode: '' },
    transactionSearch: { fromAmount: '', toAmount: '', reference: '' },
  });

  return (
    <TransactionFilterContext.Provider value={{ transactionFilter, setTransactionFilter }}>
      {children}
    </TransactionFilterContext.Provider>
  );
}
